var Parallax = function Parallax(elem) {
    var body = $('body');
    var self = this;

    this.elem = $(elem);
    this.offset = self.elem.offset().top;
    this.media = self.elem.find('.media');
    this.isVideo = self.media.hasClass('video');
    this.content = self.elem.find('.content-wrapper');
    this.contentSpeed = 2.5;
    this.opacitySpeed = 2;

    this.init = function() {
        $(window).on('scroll', this.onScroll);
        this.onScroll();
    }

    this.onScroll = function() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var elemEnd = self.elem.outerHeight() + self.offset;
        var perc = Math.min(1, scrollTop / elemEnd);
        var distanceToMove = 0;

        if (!self.isVideo) {
            distanceToMove = self.media.outerHeight() - self.elem.outerHeight();
            self.media.css('top', -distanceToMove * perc)
        } else {
            distanceToMove = self.elem.outerHeight() * 1.1 - self.elem.outerHeight();
        }

        if (self.content.length) {
            elemEnd = self.elem.outerHeight() + self.offset;
            var opacityPerc = Math.min(1, scrollTop / elemEnd);

            self.content.css('opacity', 1.0 - (opacityPerc * self.opacitySpeed));
            self.content.css('top', -(distanceToMove * self.contentSpeed) * perc);
        }
    }

    $(document).ready(function(){
        self.init();    
    });
    
};

